import { DatePicker } from 'antd';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import calender from "../../../../../../assets/images/calender-week.svg"
import dayjs, { Dayjs } from 'dayjs';
import { triggerNotification, useGetApiRequests } from '../../../../../../common/CommonExport';
import Loader from '../../../../../../components/Loader/Loader';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setProfileLoad } from '../../../../../../redux/slices/updateProfileSlice';
import PopupModal from '../../modal/PopupModal';
import { useIsMobile } from '../../../../../../hooks/commonHooks';
import moment from 'moment';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
const DeprovisionForm = ({ formDetails }: any) => {
  const employeeDetails: any = useSelector((state: any) => state?.eventData?.particularEmployeeDetails);
  const [resignDate, setResignDate] = useState('')
  const [getresignDate, setGetResignDate] = useState(employeeDetails?.relievingDate)
  const updateEmployeeDetails = useGetApiRequests('companyEmployeeDetails', 'PUT');
  const [loader, setLoader] = useState<boolean>(false)
  const { id } = useParams();
  const isMobile = useIsMobile();
  const dispatch = useDispatch();
  const [modalerrMessage, setModalErrMessage] = useState('')
  const [popModal, setPopModal] = useState(false)
  const [modalResponse, setModalResponse] = useState('')
  const [modalButtonShow, setmodalButtonShow] = useState(true)
  const [reloadTrigger, setReloadTrigger] = useState(false);
  let hrDetails: any, itAdminDetails: any, financeDetails: any, remortingManagerDetails: any;
  formDetails?.employeeDeprovisionKVDto?.map((item: any) => {
    if (item?.inchargeDescription === 'HR Admin') {
      hrDetails = item?.inchargeEmployee
    } else if (item?.inchargeDescription === 'IT Admin') {
      itAdminDetails = item?.inchargeEmployee
    } else if (item?.inchargeDescription === 'Finance Admin') {
      financeDetails = item?.inchargeEmployee
    } else if (item?.inchargeDescription === 'Reporting Manager') {
      remortingManagerDetails = item?.inchargeEmployee
    }
  })

  useEffect(() => {
    setGetResignDate(employeeDetails?.relievingDate)
  }, [employeeDetails?.relievingDate])

  const RelievingDateOnSelect = (dateString: any) => {

    let isoDate = "";

    if (dayjs(dateString, "DD/MM/YYYY", true).isValid()) {
      isoDate = dayjs(dateString, "DD/MM/YYYY").format("YYYY-MM-DD");
    } else if (dayjs(dateString, "DD-MM-YYYY", true).isValid()) {
      isoDate = dayjs(dateString, "DD-MM-YYYY").format("YYYY-MM-DD");
    }

    if (isoDate) {
      setResignDate(isoDate);
      setGetResignDate(isoDate)
    }

  }

  const handleClosePopUpModal = () => {
    setPopModal(false)
  }
  useEffect(() => {
    if (!reloadTrigger) {
      setReloadTrigger(true);
    }
  }, [employeeDetails]);
  const habdleRelievingDate = () => {
    setLoader(true)
    const insidePayload = {
      firstName: employeeDetails?.firstName,
      lastName: employeeDetails?.lastName,
      relievingDate: resignDate,
      dateOfBirth: employeeDetails?.dateOfBirth,
      bloodGroup: employeeDetails?.bloodGroup,
      fatherOrSpouseName: employeeDetails?.fatherOrSpouseName || "",
      fatherName: employeeDetails?.fatherName || "",
      motherName: employeeDetails?.motherName || "",
      personalContactNo: employeeDetails?.personalContactNo || "",
      personalEmail: employeeDetails?.personalEmail || "",
      aadharNumber: employeeDetails?.aadharNumber || "",
      panNumber: employeeDetails?.panNumber || "",
      uanNumber: employeeDetails?.uanNumber || "",
      esiNumber: employeeDetails?.esiNumber || "",
      gender: employeeDetails?.gender || "",
      isMarried: employeeDetails?.isMarried || false,
      sameAsCurrentAddress: employeeDetails?.sameAsCurrentAddress || false,
      presentAddress: {
        doorNo: employeeDetails?.presentAddress?.doorNo || "",
        street: employeeDetails?.presentAddress?.street || "",
        city: employeeDetails?.presentAddress?.city || "",
        state: employeeDetails?.presentAddress?.state || "",
        pinCode: employeeDetails?.presentAddress?.pinCode || "",
        addressId: employeeDetails?.presentAddress?.addressId || "",
      },
      permanentAddress: {
        doorNo: employeeDetails?.permanentAddress?.doorNo || "",
        street: employeeDetails?.permanentAddress?.street || "",
        city: employeeDetails?.permanentAddress?.city || "",
        state: employeeDetails?.permanentAddress?.state || "",
        pinCode: employeeDetails?.permanentAddress?.pinCode || "",
        addressId: employeeDetails?.permanentAddress?.addressId || "",
      },
      emergencyContactNo1: employeeDetails?.emergencyContactNo1 || "",
      emergencyContactNo1Relationship: employeeDetails?.emergencyContactNo1Relationship || "",
      emergencyContactNo2: employeeDetails?.emergencyContactNo2 || "",
      emergencyContactNo2Relationship: employeeDetails?.emergencyContactNo2Relationship || "",
      profileUrl: employeeDetails?.profileUrl || "",
    };

    const outerPayload = {
      employeeDto: insidePayload,
      companyDto: {},
    };
    const formData = new FormData();
    const headers = { 'Content-Type': 'multipart/form-data' };
    updateEmployeeDetails(formData, { employeeInformationDto: outerPayload }, { id: id }, headers)
      .then((res: any) => {
        dispatch(setProfileLoad());
        setPopModal(true)
        setmodalButtonShow(false)
        setModalErrMessage(res?.data?.status?.message)
        setModalResponse('success')
        setTimeout(() => {
          handleClosePopUpModal();
          window.location.reload();
          setLoader(false);
        }, 1500)
      })
      .catch((err: any) => {
        setPopModal(true)
        setmodalButtonShow(false)
        setModalErrMessage(err?.response?.data?.message)
        setModalResponse('error')
        setTimeout(() => {
          handleClosePopUpModal();
          setLoader(false);
        }, 1500)
      })
  }
  const disabledDate = (current: Dayjs) => {
    return current.isBefore(dayjs().startOf('day'));
  };
  function safeGetValue(obj: any, defaultValue = '') {
    return obj !== null && obj !== undefined ? obj : defaultValue;
  }
  const isDisabled = isMobile
    ? true
    : formDetails?.employeeDeprovisionKVDto?.some(
      (item: any) =>
        item.inchargeDescription === 'Employee' && item.status.name === 'Sent'
    );
  function parseToDayjs(dateStr: any) {
    if (dayjs(dateStr, "YYYY-MM-DD", true).isValid()) {
      return dayjs(dateStr, "YYYY-MM-DD");
    } else if (dayjs(dateStr, "DD-MM-YYYY", true).isValid()) {
      return dayjs(dateStr, "DD-MM-YYYY");
    }
    return null;
  }


  return (
    <div className='flex w-full bg-[#FCF7FB] min-h-[125px] pt-3 px-5 2xl:px-10 gap-3 2xl:gap-0 resignation-details-box'>
      <div className="w-1/3 details-row">
        <div className="flex w-full py-1">
          <p className='text-[#595959] text-[13px] 2xl:text-[16px] w-1/2 font-rubik font-medium'>HR Incharge</p>
          <p className='text-[#878787] text-[13px] 2xl:text-[16px] font-rubik '>{safeGetValue(hrDetails?.firstName, "-") + " " + safeGetValue(hrDetails?.lastName)}</p>
        </div>
        <div className="flex w-full py-1 ">
          <p className='text-[#595959] text-[13px] 2xl:text-[16px] w-1/2  font-rubik font-medium'>IT Incharge</p>
          <p className='text-[#878787] text-[13px] 2xl:text-[16px] font-rubik '>{safeGetValue(itAdminDetails?.firstName, "-") + " " + safeGetValue(itAdminDetails?.lastName)}</p>
        </div> <div className="flex w-full py-1">
          <p className='text-[#595959] text-[13px] 2xl:text-[16px] w-1/2  font-rubik font-medium'>Finance Incharge</p>
          <p className='text-[#878787] text-[13px] 2xl:text-[16px] font-rubik '>{safeGetValue(financeDetails?.firstName, "-") + " " + safeGetValue(financeDetails?.lastName)}</p>
        </div>
      </div>
      <div className="w-1/3 details-row">
        {/* <div className="flex w-full py-1">
          <p className='text-[#595959] text-[13px] 2xl:text-[16px] w-1/2 font-rubik font-medium'>Knowledge Transfer</p>
          <p className='text-[#878787] text-[13px] 2xl:text-[16px] font-rubik '>Darren Hickman</p>
        </div> */}
        <div className="flex w-full py-1 ">
          <p className='text-[#595959] text-[13px] 2xl:text-[16px] w-1/2  font-rubik font-medium'>Reporting Manager</p>
          <p className='text-[#878787] text-[13px] 2xl:text-[16px] font-rubik '>{safeGetValue(remortingManagerDetails?.firstName, "-") + " " + safeGetValue(remortingManagerDetails?.lastName)}</p>
        </div> <div className="flex w-full py-1">
          <p className='text-[#595959] text-[13px] 2xl:text-[16px] w-1/2 font-rubik font-medium'>Employee Exit Type</p>
          <p className='text-[#878787] text-[13px] 2xl:text-[16px] w-1/2 font-rubik '>{safeGetValue(employeeDetails?.resignationReason, "-")}</p>
        </div>
      </div>

      <div className="w-1/3 details-row">
        <div className="flex w-full py-1">
          <p className='text-[#595959] text-[13px] 2xl:text-[16px] w-1/2 font-rubik font-medium'>Resignation Date</p>

          <p className='text-[#878787] text-[13px] 2xl:text-[16px] font-rubik'>
            {employeeDetails?.dateOfResigned
              ? moment(employeeDetails.dateOfResigned).format('DD/MM/YYYY')
              : '-'}
          </p>
        </div>
        <div className="flex w-full py-1 ">
          <p className='text-[#595959] text-[13px] 2xl:text-[16px] w-1/2  font-rubik font-medium'>Relieving Date</p>
          <div className='w-[180px] flex'>
            <DatePicker suffixIcon={<img src={calender} className='mb-2' />} placeholder='Select relieving date' name='relieving-date' className='float-control w-full' format="DD/MM/YYYY"
              disabled={isDisabled} onChange={(date, dateString) => { RelievingDateOnSelect(dateString) }} disabledDate={disabledDate} value={getresignDate ? parseToDayjs(getresignDate) : null} />
            {employeeDetails?.relievingDate !== getresignDate &&
              <div className=' flex justify-end'><button disabled={employeeDetails?.relievingDate === getresignDate} className=' px-[5px] text-[13px] bg-[#D34A7C] text-white rounded-md ml-2' onClick={habdleRelievingDate}>Apply</button></div>
            }
          </div>
        </div>
      </div>
      {loader && <Loader />}
      {popModal && <PopupModal message={modalerrMessage} open={popModal} handleModalClose={handleClosePopUpModal} response={modalResponse} modalButtonShow={modalButtonShow} />}

    </div>
  )
}

export default DeprovisionForm